// Rows of a pick-resource modal hang their hover-only actions off this group, so the class has to
// match the `md:group-hover/campaign-pick-item:*` variants used by the shared action components.
export const CAMPAIGN_PICK_ITEM_GROUP_CLASS = 'group/campaign-pick-item';

export const MODAL_REMOVE_FROM_EXPERIMENT_IDENTIFIER = 'modal-remove-from-experiment-identifier';

export const MODAL_EDIT_EXPERIMENTS_IDENTIFIER = 'modal-edit-experiments-identifier';
